





















































import Vue from 'vue';
import { HubButton, HubCheckbox } from '@/components/HubComponents';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
  name: 'ViewFacebook' as string,

  components: { HubButton, HubCheckbox },

  props: {
    hash: {
      type: String,
      required: true,
    },
    userDataString: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isSaveButtonLoading: false,
      accounts: [] as Views.ViewFacebook.SelectedAccount[],
    };
  },

  computed: {
    ...mapState(['events', 'liveSocial', 'user']),
    description(): string {
      return this.liveSocial.general.description;
    },
    eventState(): Store.Events.Event {
      return this.events.event;
    },
    selectedAccounts(): Views.ViewFacebook.SelectedAccount[] {
      return this.accounts.filter((account) => account.selected);
    },
    title(): string {
      return this.liveSocial.general.title;
    },
    userData(): Store.LiveSocial.Facebook.UserData {
      return this.userDataString
        ? JSON.parse(this.userDataString)
        : null;
    },
    userState(): Store.User.State {
      return this.user;
    },
  },

  async mounted() {
    if (this.userData) this.fillAccountsArray();
    else this.redirectsToViewLiveSocial();

    await this.loadEvent({
      planId: parseInt(this.userState.planId, 10),
      hash: this.hash,
    } as Services.Events.GetEvent);

    await this.loadLiveSocialGeneral({
      customer_plans_events_id: this.eventState.id,
      customer_plans_id: this.userState.planId,
    } as Services.LiveSocial.GetLiveSocialGeneral);
  },

  methods: {
    ...mapActions({
      createService: 'liveSocial/createService',
      createWowzaTarget: 'liveSocial/facebookCreateStreamTarget',
      loadEvent: 'events/loadEvent',
      loadLiveSocialGeneral: 'liveSocial/loadLiveSocialGeneral',
    }),
    setTargetName(data: Services.LiveSocial.Facebook.SetTargetName): string {
      const {
        customerPlanName,
        provider,
        streamType,
        transmissionId,
      } = data;

      const providers = {
        custom: 'OT', // OT = others
        facebook: 'FB',
        instagram: 'IT',
        twitch: 'TC',
        twitter: 'TW',
        youtube: 'YT',
      };

      return `${providers[provider]}-${streamType}-${customerPlanName}-${transmissionId}`;
    },
    getTargetSettings(streamingUrl: string): Services.LiveSocial.Facebook.TargetSettings | null {
      const regex = /^(rtmps|rtmp)?(:\/\/)?([a-z]*-*[a-z-a-z.a-z*.a-z]*)?(:)?([0-9]*)?(\/)?([a-z0-9]*)/i;

      const config = regex.exec(streamingUrl);

      return config
        ? {
          destinationApplication: config[7],
          destinationHost: config[3],
          destinationPort: config[5] || '1935',
          destinationUseSsl: config[5] && config[5] === '443' ? 'true' : 'false',
        }
        : null;
    },
    assembleProviderSettings(
      payload: Services.LiveSocial.Facebook.Response.PostLive,
    ): Store.LiveSocial.ProviderSettings {
      const splitUrl = payload.stream_url.split('/');
      const streamUrlSecure = payload.secure_stream_url.split('/')[2];

      return {
        streaming_id: payload.id,
        streaming_key: splitUrl[4],
        streaming_secure_url: `rtmps://${streamUrlSecure}/rtmp`,
        streaming_url: `rtmp://${splitUrl[2]}/rtmp`,
      };
    },
    createServiceOnFacebookApi(
      payload: Services.LiveSocial.Facebook.PostLive,
    ): Promise<Services.LiveSocial.Facebook.Response.PostLive> {
      return this.$store.dispatch('liveSocial/facebookCreateService', payload);
    },
    createUserAccount(
      payload: Services.LiveSocial.PostUserAccount,
    ): Promise<Store.LiveSocial.UserSocialNetwork> {
      return this.$store.dispatch('liveSocial/createUserAccount', payload);
    },
    fillAccountsArray(): void {
      this.accounts.push({
        id: this.userData.id,
        name: this.userData.name,
        picture: this.userData.urlProfilePicture,
        selected: false,
        type: 'feed',
      });

      if (this.userData.pages.length) {
        const pages = this.userData.pages.map((page) => ({
          id: page.id,
          name: page.name,
          picture: page.urlPicture,
          selected: false,
          type: 'page',
        })) as Views.ViewFacebook.SelectedAccount[];

        this.accounts.push(...pages);
      }
    },
    getUserAccountByUserId(
      payload: Services.LiveSocial.GetUserAccountByUserId,
    ): Promise<Store.LiveSocial.UserSocialNetwork> {
      return this.$store.dispatch('liveSocial/loadUserAccountByUserId', payload);
    },
    async onSave(): Promise<void> {
      this.isSaveButtonLoading = true;

      let newUserSocial: Store.LiveSocial.UserSocialNetwork;
      // mounting array of services to be created
      const services = this.selectedAccounts.map((account) => {
        const pageOnUserData = this.userData.pages.filter((page) => (
          page.id === account.id
        ));

        return account.type === 'page'
          ? {
            user_id: this.userData.id,
            page_id: account.id,
            title: this.title,
            description: this.description,
            stream_type: 'REGULAR',
            url_picture: pageOnUserData[0].urlPicture,
            email: this.userData.email,
            name: account.name,
          }
          : {
            user_id: this.userData.id,
            title: this.title,
            description: this.description,
            stream_type: 'REGULAR',
            url_picture: this.userData.urlProfilePicture,
            email: this.userData.email,
            name: account.name,
          };
      }) as Services.LiveSocial.Facebook.PostLive[];
      // check if user account is already saved on database
      const userSocial = await this.getUserAccountByUserId({
        customerPlansEventsId: this.eventState.id,
        customerPlansId: this.userState.planId,
        userId: this.userData.id,
      });
      // if user wasn't found, we create one in our database
      if (!userSocial.id) {
        newUserSocial = await this.createUserAccount({
          customer_plans_events_id: this.eventState.id,
          customer_plans_id: parseInt(this.userState.planId, 10),
          email: this.userData.email,
          name: this.userData.name,
          provider: 'facebook',
          token: this.userData.access_token,
          user_data: JSON.stringify(this.userData),
          user_id: this.userData.id,
        });
      }

      let targetData: Services.LiveSocial.Facebook.CreateWowzaTarget;

      // function declaration to be used on promise.all
      const createServiceFullProcess = async (
        service: Services.LiveSocial.Facebook.PostLive,
      ): Promise<Services.LiveSocial.Response.PostService> => {
        const serviceCreatedOnFacebookApi = await this.createServiceOnFacebookApi(service);

        const providerSettings = this.assembleProviderSettings(serviceCreatedOnFacebookApi);

        // create facebook wowza stream target
        const targetSettings = this.getTargetSettings(providerSettings.streaming_url);

        if (targetSettings) {
          targetData = {
            application: `LVW-${this.eventState.customer_plans_lvw_id}`,
            sourceStreamName: this.eventState.stream,
            entryName: this.setTargetName({
              customerPlanName: `EVT-${this.eventState.customer_plans_id}`,
              provider: 'facebook',
              streamType: 'REGULAR',
              transmissionId: service.page_id ? service.page_id : serviceCreatedOnFacebookApi.id,
            }),
            destination_host: targetSettings.destinationHost,
            destination_application: targetSettings.destinationApplication,
            destination_port: targetSettings.destinationPort,
            destination_stream_name: providerSettings.streaming_key,
            destination_use_ssl: targetSettings.destinationUseSsl,
          };
          console.log('tryng to create wowza target: ', targetData);
          await this.createWowzaTarget(targetData);
        }

        return this.createService({
          description: this.description,
          email: service.email,
          id_customer_plans: parseInt(this.userState.planId, 10),
          id_customer_plans_events: this.eventState.id,
          name: service.name,
          provider: 'facebook',
          provider_settings: JSON.stringify(providerSettings),
          social_id: newUserSocial ? newUserSocial.id.toString() : userSocial.id.toString(),
          stream_type: 'REGULAR',
          title: this.title,
          transmission_id: service.page_id ? service.page_id : serviceCreatedOnFacebookApi.id,
          transmission_type: service.page_id ? 'page' : 'feed',
          url_picture: service.url_picture,
          process_name: targetData.entryName,
        } as Services.LiveSocial.PostService);
      };

      const promises: Promise<Services.LiveSocial.Response.PostService>[] = [];

      services.forEach((service) => {
        promises.push(createServiceFullProcess(service));
      });

      Promise.all(promises).then(() => {
        this.isSaveButtonLoading = false;
        this.redirectsToViewLiveSocial();
      })
        .catch((error) => {
          console.log('an error occurred', error);
          this.isSaveButtonLoading = false;
        });
    },
    redirectsToViewLiveSocial(): void {
      this.$router.push({ name: 'LiveSocial', params: { hash: this.hash } });
    },
  },
});
